// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Resources } from '@shared/localizations/Resources';
import { Instrument } from '../../../Instrument';
import { BaseOrderWarning } from './BaseOrderWarning';
export class SMFlagsWarning extends BaseOrderWarning {
    getText() {
        const result = this.getSMFlagsWarning();
        if (!result) {
            return '';
        }
        const textToInsert = ' - ' + result;
        const text = Resources.getResource('FlagSM.Message', [textToInsert]);
        return text;
    }
    getSMFlagsWarning() {
        const ins = this.orderEdit.instrument;
        const flags = ins ? ins.GetExtSMFlags() : {};
        let result = '';
        for (const flag in flags) {
            const flagValue = ins === null || ins === void 0 ? void 0 : ins.GetExtSMFlagByKey(flag);
            if (Instrument.ShownSMFlagValue(flags[flag], flag)) {
                result += (result ? ', ' : '') + flagValue;
            }
        }
        return result;
    }
}
